import { ActionReducerMap } from '@ngrx/store';

export interface DsAppState {}

export const appReducer: ActionReducerMap<DsAppState> = {};
